// Avatar catalog. Each avatar is stored as "style:seed"; resolved to a DiceBear SVG URL.
// Categories: humans, animals, robots, monsters, funny.

export const AVATARS = [
  // Humans
  { id: "adventurer:Milo", cat: "Humans" },
  { id: "adventurer:Zara", cat: "Humans" },
  { id: "personas:Kai", cat: "Humans" },
  { id: "personas:Nova", cat: "Humans" },
  { id: "micah:Rex", cat: "Humans" },
  { id: "micah:Luna", cat: "Humans" },
  { id: "open-peeps:Bruno", cat: "Humans" },
  { id: "open-peeps:Sami", cat: "Humans" },
  // Animals
  { id: "bottts:Tiger", cat: "Animals" },
  { id: "thumbs:Panda", cat: "Animals" },
  { id: "fun-emoji:Fox", cat: "Animals" },
  { id: "fun-emoji:Owl", cat: "Animals" },
  { id: "croodles:Cat", cat: "Animals" },
  { id: "croodles:Dog", cat: "Animals" },
  // Robots
  { id: "bottts:Bolt", cat: "Robots" },
  { id: "bottts:Circuit", cat: "Robots" },
  { id: "bottts:Widget", cat: "Robots" },
  { id: "bottts:Servo", cat: "Robots" },
  { id: "pixel-art:Byte", cat: "Robots" },
  { id: "pixel-art:Glitch", cat: "Robots" },
  // Monsters
  { id: "fun-emoji:Blob", cat: "Monsters" },
  { id: "fun-emoji:Goblin", cat: "Monsters" },
  { id: "croodles:Yeti", cat: "Monsters" },
  { id: "big-ears:Fang", cat: "Monsters" },
  { id: "big-ears:Grumble", cat: "Monsters" },
  // Funny
  { id: "fun-emoji:Giggles", cat: "Funny" },
  { id: "fun-emoji:Wacky", cat: "Funny" },
  { id: "thumbs:Chief", cat: "Funny" },
  { id: "thumbs:Doodle", cat: "Funny" },
  { id: "croodles:Silly", cat: "Funny" },
  { id: "big-smile:Sunny", cat: "Funny" },
  { id: "big-smile:Grin", cat: "Funny" },
];

export function avatarUrl(str) {
  if (!str || typeof str !== "string") str = "fun-emoji:Blob";
  let [style, seed] = str.includes(":") ? str.split(":") : ["fun-emoji", str];
  if (style === "seed") style = "fun-emoji";
  const bg = "F4EBD0,FDFBF7,FFE9A8,BAE3FB,FAC7D9,C7EFC2";
  return `https://api.dicebear.com/7.x/${style}/svg?seed=${encodeURIComponent(seed)}&backgroundColor=${bg}&radius=10`;
}

export function randomAvatar() {
  return AVATARS[Math.floor(Math.random() * AVATARS.length)].id;
}
